import { JsonProperty, Serializable } from "typescript-json-serializer";
import { IPaging } from "./IPaging";

@Serializable()
export abstract class AbstractPaging<T> implements IPaging<T> {
    @JsonProperty()
    pageNumber: number;

    @JsonProperty()
    pageSize: number;

    @JsonProperty()
    totalCount: number;

    @JsonProperty()
    totalPages: number;

    @JsonProperty()
    content: Array<T>;
}